const steps = [
  {
    num: "01",
    icon: "ri-trophy-line",
    title: "電力会社を選ぶ",
    desc: "気になる電力会社の公式サイトへ",
  },
  {
    num: "02",
    icon: "ri-computer-line",
    title: "公式サイトで申し込み",
    desc: "選んだ電力会社の公式サイトからオンラインでお申し込みいただけます。書類不要で約5分で完了します。",
  },
  {
    num: "03",
    icon: "ri-exchange-line",
    title: "切り替えが完了",
    desc: "数日で電気の切り替えが完了します。工事や立ち会いは原則不要です！",
  },
  {
    num: "04",
    icon: "ri-flashlight-line",
    title: "ご利用開始",
    desc: "そのまま今まで通りに電気をご利用いただけます。スマートに節電・節約がスタートします。",
  },
];

export default function HowToSection() {
  return (
    <section id="how-to" className="py-20 bg-white relative overflow-hidden">
      {/* Background image - bright, matching main visual tone */}
      <div className="absolute inset-0 opacity-25">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20all-electric%20Japanese%20house%20exterior%20bright%20clean%20daylight%20white%20walls%20green%20garden%20solar%20panels%20on%20roof%20residential%20home%20minimalist%20warm%20sunlight%20environment%20sustainable%20energy%20friendly%20photography%20soft%20focus%20background"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Soft brand overlay for cohesion */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-brand-50/60 to-white/90" />

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold tracking-widest text-brand-600 uppercase mb-2 block">
            STEP BY STEP
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            申し込みの流れ
          </h2>
          <p className="text-gray-500 text-sm">
            最短5分・工事不要・書類不要で切り替えが完了します
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative">
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-9 left-full w-full h-px bg-brand-200 z-0 -translate-x-1/2" />
              )}

              <div className="bg-white border border-brand-100 rounded-xl p-6 relative z-10 h-full shadow-sm hover:shadow-md transition-all">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-brand-50 border border-brand-100 flex-shrink-0">
                    <i className={`${step.icon} text-brand-500`} />
                  </div>
                  <span className="text-2xl font-bold text-brand-100">{step.num}</span>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <p className="text-gray-500 text-sm mb-5">今すぐランキングをチェックして電気代を節約しましょう</p>
          <a
            href="#ranking"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-brand-500 hover:bg-brand-600 text-white font-bold px-10 py-4 rounded-lg text-base transition-all cursor-pointer"
          >
            <i className="ri-trophy-line" />
            ランキングへ戻る
          </a>
        </div>
      </div>
    </section>
  );
}